import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=636c683a&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=ts&"
export * from "./coupon.vue?vue&type=script&lang=ts&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=636c683a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c683a",
  null
  
)

export default component.exports